angular.module('impactx.cube').service('CubeConfigService', CubeConfigService);

CubeConfigService.$inject = ['dataGen', '$redirect', '$mdDialog', 'NewCubeService', '$q'];

/**
 * Service for configuring a cube
 * @param dataGen Data service
 * @constructor
 */
function CubeConfigService(dataGen, $redirect, $mdDialog, NewCubeService, $q) {
    var vm = this;

    vm.columnLevelDrillDownIndex = 0;
    vm.rowLevelDrillDownIndex = 0;

    /**
     * initialize the service by getting the data from the server
     * @param scope
     * @returns {*}
     */
    this.init = function (scope) {
        vm.oldCube = vm.selectedCube;
        vm.selectedCube = {};
        if (!vm.cubeConfigs) {
            return dataGen.getData(scope, {}, "/monitor/cube/config").then(function () {
                vm.reset();
                vm.cubeConfigs = scope.data.cubeConfigs;
                scope.data.minDate = new Date(scope.data.minDate);
                scope.data.maxDate = new Date(scope.data.maxDate);
                vm.minDate = scope.data.minDate;
                vm.maxDate = scope.data.maxDate;
                vm.trns = scope.trns;
            });
        } else {
            scope.data = {};
            scope.data.cubeConfigs = vm.cubeConfigs;
            scope.data.minDate = vm.minDate;
            scope.data.maxDate = vm.maxDate;
            scope.trns = vm.trns;
        }
        return $q.when();
    };

    /**
     * Method to select a cube
     * @param config Cube config to select
     */
    this.selectCube = function (config) {
        vm.reset();
        vm.selectedCube.cube = config;
        if (config.defaultColumn) {
            vm.selectedCube.columns.push(config.defaultColumn);
        }
        if (config.defaultRow) {
            vm.selectedCube.rows.push(config.defaultRow);
        }
        if (config.defaultMeasure) {
            vm.selectedCube.measures.push(config.defaultMeasure);
        }
        var scope = {};
        return dataGen.postAsForm(scope, {cube: vm.selectedCube}, "/monitor/cube/filter").then(function () {
            vm.filters = scope.data.filters;
        });
    };

    /**
     * Add a column to the config
     */
    this.addColumn = function () {
        vm.selectedCube.columns.push(vm.selectedCube.cube.defaultColumn);
    };

    /**
     * Remove the i-th column from the config
     * @param i
     */
    this.removeColumn = function (i) {
        vm.selectedCube.columns.splice(i, 1)
    };

    /**
     * Add a row to the config
     */
    this.addRow = function () {
        vm.selectedCube.rows.push(vm.selectedCube.cube.defaultRow);
    };

    /**
     * Remove the i-th row from the config
     * @param i
     */
    this.removeRow = function (i) {
        vm.selectedCube.rows.splice(i, 1)
    };

    /**
     * Add a column to the measure
     */
    this.addMeasure = function () {
        vm.selectedCube.measures.push(vm.selectedCube.cube.defaultMeasure);
    };

    /**
     * Remove the i-th measure from the config
     * @param i
     */
    this.removeMeasure = function (i) {
        vm.selectedCube.measures.splice(i, 1)
    };

    /**
     * Reset the configuration
     */
    this.reset = function reset() {
        if (!vm.selectedCube) {
            vm.selectedCube = {};
        }
        vm.selectedCube.cube = null;
        vm.selectedCube.rows = [];
        vm.selectedCube.filters = [];
        vm.selectedCube.columns = [];
        vm.selectedCube.measures = [];
        vm.selectedCube.drillDowns = [];
        vm.selectedCube.newDrillDowns = [];
        vm.selectedCube.removeDrillDowns = [];
        vm.columnLevelDrillDownIndex = 0;
        vm.rowLevelDrillDownIndex = 0;
    };

    this.deleteCache = function () {
        vm.selectedCube = null;
        vm.columnLevelDrillDownIndex = 0;
        vm.rowLevelDrillDownIndex = 0;
    };

    this.cancelInternal = function () {
        $mdDialog.cancel();
        NewCubeService.dialogOpen = false;
    };

    this.cancel = function () {
        vm.selectedCube = vm.oldCube;
        vm.cancelInternal();
    };

    this.close = function () {
        vm.cancelInternal();
        $redirect.redirectTo(null, "/cube")
    }

}
